import styled from "styled-components";
import { Link } from "react-router-dom";

export default function Catalogo(){

    const items = [
        {
            title: "Ficha Técnica",
            desc: "Explore especificações completas de veículos: motor, desempenho, consumo e muito mais.",
            link: "/ficha-tecnica"
        },
        {
            title: "Comparativo",
            desc: "Compare veículos lado a lado e descubra qual atende melhor às suas necessidades.",
            link: "/comparacao"
        },
        {
            title: "Tabela Fipe",
            desc: "Consulte valores atualizados de veículos no mercado brasileiro.",
            link: "/tabela-fipe"
        },
        {
            title: "Mais vendidos",
            desc: "Veja os carros mais vendidos e populares do momento.",
            link: "/mais-vendidos"
        },
        {
            title: "Opinião do leitor",
            desc: "Avaliações e opiniões reais de usuários sobre diversos veículos.",
            link: "/opiniao"
        }
    ];

    return (
        <Container>
            <Header>
                <h1>Catálogo</h1>
                <p>Explore todas as informações automotivas em um só lugar</p>
            </Header>

            <Grid>
                {items.map((item, index) => (
                    <Card key={index}>
                        <Content>
                            <h3>{item.title}</h3>
                            <p>{item.desc}</p>
                        </Content>

                        <StyledLink to={item.link}>
                            Acessar
                        </StyledLink>
                    </Card>
                ))}
            </Grid>
        </Container>
    );
}

/* CONTAINER */
const Container = styled.div`
    padding: 60px 40px;
    background-color: #111;
    color: #fff;
    min-height: 100vh;
`;

/* HEADER */
const Header = styled.div`
    text-align: center;
    margin-bottom: 50px;

    h1{
        font-size: 42px;
        color: #ff1a1a;
        margin-bottom: 10px;
    }

    p{
        font-size: 16px;
        opacity: 0.8;
    }
`;

/* GRID */
const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 25px;
`;

/* CARD */
const Card = styled.div`
    background: #1a1a1a;
    padding: 25px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid transparent;
    transition: 0.3s;

    &:hover{
        transform: translateY(-5px);
        border-color: #ff1a1a;
    }
`;

const Content = styled.div`
    h3{
        margin-bottom: 10px;
    }

    p{
        font-size: 14px;
        opacity: 0.8;
        margin-bottom: 20px;
    }
`;

/* BOTÃO */
const StyledLink = styled(Link)`
    text-align: center;
    padding: 10px;
    border-radius: 6px;
    text-decoration: none;
    font-weight: bold;
    background: linear-gradient(90deg, #b30000, #ff1a1a);
    color: white;
    transition: 0.3s;

    &:hover{
        opacity: 0.85;
    }
`;